"use strict";
// it disabled because `object` is the only type which can be used as non-scalar type
/* eslint-disable @typescript-eslint/ban-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullContext = exports.cancelFuncKey = exports.cancelPromiseKey = exports.canceledKey = exports.childrenKey = exports.idKey = void 0;
exports.context = context;
exports.walk = walk;
exports.cancel = cancel;
exports.onceCanceled = onceCanceled;
const adapter_1 = require("../../../api/adapter");
exports.idKey = Symbol("id");
exports.childrenKey = Symbol("children");
exports.canceledKey = Symbol("canceled");
exports.cancelPromiseKey = Symbol("cancelPromise");
exports.cancelFuncKey = Symbol("cancelFunc");
let lastId = 1;
exports.NullContext = {
    [exports.idKey]: 0,
    [exports.childrenKey]: [],
    [exports.canceledKey]: false,
    [exports.cancelPromiseKey]: Promise.resolve("null context"),
    [exports.cancelFuncKey]: () => undefined,
};
/**
 * Creates new context with specified values.
 * If `parent` is passed then the context will inherit all parents values
 * Make sure you always pass new context to another function even
 * if it doesn't have any new values.
 *
 * Example:
 * ```
 * function bar(ctx: AnyContext) {
 *   // a new context with the same values
 *   console.log(ctx.contextKey);
 * }
 *
 * function foo(ctx: AnyContext) {
 *   // do something with ctx
 *   bar(context(ctx));
 * }
 *
 * foo(context({contextKey: "value"}));
 * ```
 */
function context(values, parent = exports.NullContext) {
    const par = parent === exports.NullContext ? {} : parent;
    const ctx = {
        ...par,
        ...values,
        [exports.idKey]: lastId++,
        [exports.childrenKey]: [],
        [exports.canceledKey]: false,
        [exports.cancelFuncKey]: () => undefined,
    };
    ctx[exports.cancelPromiseKey] = new Promise((r) => {
        ctx[exports.cancelFuncKey] = r;
    }).then((reason) => {
        ctx[exports.canceledKey] = true;
        return reason;
    });
    if (par[exports.childrenKey] != null) {
        par[exports.childrenKey].push(ctx);
        if (par[exports.canceledKey]) {
            ctx[exports.cancelFuncKey]("parent context is canceled");
        }
    }
    return ctx;
}
function walk(ctx, out = [], remove = false) {
    for (const child of ctx[exports.childrenKey]) {
        walk(child, out, remove);
    }
    if (remove) {
        // remove it to avoid a leak
        ctx[exports.childrenKey].splice(0, ctx[exports.childrenKey].length);
    }
    out.push(ctx);
    return out;
}
/**
 * Cancel the passed context and all children contexts
 * If `reason` is provided then it will be passed to the cancel promise
 * @See `onceCanceled`
 */
function cancel(ctx, reason = "not specified") {
    if (ctx[exports.canceledKey]) {
        return;
    }
    const children = walk(ctx, [], true);
    for (const child of children) {
        adapter_1.device.setTimeout(() => {
            child[exports.cancelFuncKey](reason);
            child[exports.canceledKey] = true;
        }, 0);
    }
}
/**
 * Returns a promise which resolves once the context is canceled
 * Resolve argument is a cancellation reason
 * @See `cancel`
 */
function onceCanceled(ctx) {
    return ctx[exports.cancelPromiseKey];
}
//# sourceMappingURL=context.js.map